import { CustomAccordionExpandIcon } from '@aibees/elephant/components/custom-accordion-expand-icon';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
  Box,
  Typography,
} from '@mui/material';
import { memo, useCallback, useState } from 'react';
import * as SX from './sx';
import type { FilterSectionProps as Props } from './types';

const ACCORDION_SLOT_PROPS = {
  transition: { unmountOnExit: true as const },
};

export const FilterSection = memo(
  ({ className, title, open: defaultOpen, children }: Props) => {
    const [open, setOpen] = useState<boolean>(defaultOpen ?? false);
    const handleChange = useCallback(() => {
      setOpen((prev) => !prev);
    }, []);

    return (
      <Box width="100%">
        <Accordion
          className={classnames('FilterSection', className)}
          variant="filled"
          color="transparent"
          expanded={open}
          slotProps={ACCORDION_SLOT_PROPS}
        >
          <AccordionSummary
            onClick={handleChange}
            expandIcon={<CustomAccordionExpandIcon open={open} />}
            sx={SX.summary}
          >
            <Box display="flex" alignItems="center" gap={0.5}>
              {defaultOpen && (
                <>
                  <Badge color="primary" variant="dot" size={6} />
                  <Box marginRight={0.2} />
                </>
              )}
              <Icon
                color={open ? 'primary' : 'grey.700'}
                size={16}
                name="setting-1"
              />
              <Typography color={open ? 'primary' : 'grey.700'} variant="body4">
                {title}
              </Typography>
            </Box>
          </AccordionSummary>

          <AccordionDetails sx={SX.details}>
            <Box display="flex" flexDirection="column" gap={1}>
              {children}
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    );
  }
);

FilterSection.displayName = 'FilterSection';
